import { Injectable } from '@angular/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { ProjConstants } from 'src/app/utils/proj.constant';
import { isNullOrUndefined } from 'util';
import { ExtremeWeatherDataService } from '../extreme-weather-data.service';

@Injectable({
  providedIn: 'root'
})
export class RainfallService {

  alertCategoryMapping = {no_rain: 'no rain', light_rain : 'light rain', moderate_rain : 'moderate rain' , heavy_rain : 'heavy rain' , very_heavy_rain : 'very heavy rain'}
  alertCategoryColorMapping = {
    no_rain: '#FFFFFF',
    light_rain : '#01FF04',
    moderate_rain : '#048500',
    heavy_rain : '#FDC0CB',
    very_heavy_rain : '#FC0300'
  }

  constructor(private utilService: UtilsService,private extremeWeatherDataService: ExtremeWeatherDataService) { }

  setRainfallData(data, adminSelected, route, location) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1), blockLength: element['blockLength'] };
        } else if (element['blockLength'] == 'day') {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1), blockLength: element['blockLength'] };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1), blockLength: element['blockLength'] };
        }
        if(!isNullOrUndefined(element)) {
          object['Category'] = { val : this.alertCategoryMapping[element['alert']] , backgroundColor: this.alertCategoryColorMapping[element['alert']] }
        }  
      }
      if (adminSelected) {
        locName = this.utilService.formatNames(data[item]['name']);
        object['State'] = { val: locName };
      } else {
        locName = this.utilService.formatNames(data[item]['name']);
        object['Basin'] = { val: locName };
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataUnsorted.push(object);
    }
    tableData = tableDataUnsorted;
    finalData['data'] = tableData;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, false, location);
    // if(!isNullOrUndefined(alertData)) {
      cols.push({
        val : 'Category',
        colspan : 1,
        rowspan : 1,
        sortedHeaderVal : 'Category'
      })
    // }
    
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setRainfallDataWeekly(data, adminSelected, route, location?) {
    const finalData = {};
    let tableData = [];
    const tableDataUnsorted = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1), blockLength: element['blockLength'] };
        }
        else if (element['blockLength'] == 'day') {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1), blockLength: element['blockLength'] };
        }
        else {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1), blockLength: element['blockLength'] };
        }
        if(!isNullOrUndefined(element)) {
          object['Category'] = { val : this.alertCategoryMapping[element['alert']] , backgroundColor: this.alertCategoryColorMapping[element['alert']] }
        }  
      }
      if (adminSelected) {
        locName = this.utilService.formatNames(data[item]['name']);
        object[location] = { val: locName };
      } else {
        locName = this.utilService.formatNames(data[item]['name']);
        object['Basin'] = { val: locName };
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataUnsorted.push(object);
    }
    tableData = tableDataUnsorted;
    finalData['data'] = tableData;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, false, location);
    // if(!isNullOrUndefined(alertData)) {
      cols.push({
        val : 'Category',
        colspan : 1,
        rowspan : 1,
        sortedHeaderVal : 'Category'
      })
    // }
    tableColumns.push(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  createColumns(columns, adminSelected, isMandal, location?) {
    const finalColumns = [];
    if (adminSelected) {
      if (isMandal) {
        finalColumns.push({
          val: 'Mandal',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Mandal'
        });
      }
      if(location == 'STATE') {
        finalColumns.push({
          val: 'State',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'State'
        });
      } else if(location == 'District'){
        finalColumns.push({
          val: 'District',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'District'
        });
      } else {
        finalColumns.push({
          val: 'Block',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'Block'
        });
      } 
    } else {
      if (isMandal) {
        finalColumns.push({
          val: 'Sub Basin',
          colspan: 1,
          rowspan: 1,
          sortedHeaderVal: 'SubBasin'
        });
      }
      finalColumns.push({
        val: 'Basin',
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: 'Basin'
      });
    }
    for (const element in columns) {
      finalColumns.push({
        val: columns[element],
        colspan: 1,
        rowspan: 1,
        sortedHeaderVal: columns[element]
      });
    }
    return finalColumns;
  }

  createColumnsVillage(columns,adminSelected,isVillage){
    let finalColumns = [];
    if(adminSelected){
      if(isVillage){
        finalColumns.push({
          val : 'Village',
          colspan : 1,
          rowspan : 1,
          sortedHeaderVal : 'Village'
        })
      }
      finalColumns.push({
        val : 'Mandal',
        colspan : 1,
        rowspan : 1,
        sortedHeaderVal : 'Mandal'
      })
    }
    for(let element in columns){
      finalColumns.push({
        val : columns[element],
        colspan : 1,
        rowspan : 1,
        sortedHeaderVal : columns[element]
      })
    }
    return finalColumns;
  }

  setBlockArray(data, route) {
    let rainfallDataKeys;
    for (const item of Object.keys(data)) {
      rainfallDataKeys = [];
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '6hr' || element['blockLength'] == '3hr') {
          rainfallDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == '24hr') {
          rainfallDataKeys.push('24hr');
        } else if (element['blockLength'] == 'day') {
          rainfallDataKeys.push(element['timeStamp']);
        } else {
          rainfallDataKeys.push(element['timeStamp']);
        }
      }
    }
    return this.sortKeys(rainfallDataKeys, route);
  }

  setBlockArray1(data, route) {
    let rainfallDataKeys;
    for (const item of Object.keys(data)) {
      rainfallDataKeys = [];
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '6hr' || element['blockLength'] == '3hr') {
          rainfallDataKeys.push(element['timeStamp']);
        } else if (element['blockLength'] == '24hr') {
          rainfallDataKeys.push('24hr');
        } else if (element['blockLength'] == 'day') {
          rainfallDataKeys.push(element['timeStamp']);
        } else if(element['blockLength'] == 'hourly'){
          rainfallDataKeys.push(element['timeStamp']);
        } else {
          rainfallDataKeys.push(element['timeStamp']);
        }
      }
    }
    return this.sortKeys(rainfallDataKeys, route);
  }

  setMandalData(data, adminSelected, route) {
    const finalData = {};
    const tableDataMandal = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      let pName = '';
      if (adminSelected) {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Mandal'] = { val: locName };
        object['District'] = { val: pName };
      } else {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Sub Basin'] = { val: locName };
        object['Basin'] = { val: pName };
      }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1) };
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, true);
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setVillageData(data,adminSelected,route) {
    let finalData = {};
    let tableDataMandal = [];
    for (let item of Object.keys(data)) {
      let object = [];
      let locName = '';
      let pName = '';
      pName = this.utilService.formatNames(data[item]['pName']);
      locName = this.utilService.formatNames(data[item]['name']);
      object['Village'] = {
        val : locName };
      object['Mandal'] = {
        val : pName};
        for (const element of data[item]['table_data']) {
          if (element['blockLength'] == '24hr') {
            object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
          } else {
            object[element['timeStamp']] = { val: Number(element['data']['rf']).toFixed(1) };
          }
        }
      if(data[item]['centroid'] != undefined && data[item]['centroid'] != null){
        object['centroid'] = data[item]['centroid'];
      }
      if(data[item]['uuid'] != undefined && data[item]['uuid'] != null) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal

    let tableColumns = [];
    let cols = this.createColumnsVillage(this.setBlockArray(data,route),true,true)
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setWeeklyMandalData(data, adminSelected, route,type) {
    const finalData = {};
    const tableDataMandal = [];
    for (const item of Object.keys(data)) {
      const object = [];
      let locName = '';
      let pName = '';
      if (adminSelected) {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Mandal'] = { val: locName };
        object['District'] = { val: pName };
      } else {
        pName = this.utilService.formatNames(data[item]['pName']);
        locName = this.utilService.formatNames(data[item]['name']);
        object['Sub Basin'] = { val: locName };
        object['Basin'] = { val: pName };
      }
      for (const element of data[item]['table_data']) {
        if (element['blockLength'] == '24hr') {
          object['24hr'] = { val: Number(element['data']['rf']).toFixed(1) };
        } else {
          if(type=='mean'){
            object[element['timeStamp']] = { val: Number(element['data']['mnRf']).toFixed(1) };
          }else if(type=='median'){
            object[element['timeStamp']] = { val: Number(element['data']['mdRf']).toFixed(1) };
          }
        }
      }
      if (data[item]['centroid'] != undefined && data[item]['centroid'] != null) {
        object['centroid'] = data[item]['centroid'];
      }
      if (!isNullOrUndefined(data[item]['uuid'])) {
        object['uuid'] = data[item]['uuid'];
      }
      tableDataMandal.push(object);
    }
    finalData['data'] = tableDataMandal;

    const tableColumns = [];
    const cols = this.createColumns(this.setBlockArray(data, route), adminSelected, true);
    tableColumns.push(cols);
    // console.log(cols);
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = cols;
    return finalData;
  }

  setChartData(data, ProjConstants) {
    const keys = Object.keys(data);
    const formattedChartData = [];
    for (const key of keys) {
      const obj = {};
      for (const item of Object.keys(data[key])) {

        if (item == '6hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[key][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[key][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[key][item][timestamp];
          }
        }
      }
      obj[ProjConstants.CHART_DATA_COLUMNS['RAINFALL']] = key;
      formattedChartData.push(obj);
    }
    return formattedChartData;
  }
  
  formatDataForChart(data) {
    const chartData = {};
    for (const range of Object.keys(data)) {
      const obj = {};
      for (const item of Object.keys(data[range])) {
        if (item == '6hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        } else if (item == '24hr') {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj['24hr'] = data[range][item][timestamp];
          }
        } else {
          const timeStamps = Object.keys(data[range][item]);
          for (const timestamp of timeStamps) {
            obj[timestamp] = data[range][item][timestamp];
          }
        }
      }
      chartData[range] = obj;
    }
    return chartData;
  }
  
  sortKeys(data, route) {
    // console.log("CHECKDATA",data);
    const returnArray = [];
    let dummyArray = [];
    
    for (const timestamp of data) {
      if (route.snapshot.paramMap.get('time') == '24' && timestamp == '24hr') {
        returnArray.push(timestamp);
      } else {
        dummyArray.push(timestamp);
      }
    }
    dummyArray = dummyArray.sort();
    for (const ele of dummyArray) {
      returnArray.push(ele);
    }
    return returnArray;
  }

  get24HrsTimeStamps(source) {
    // ---------------33435 IMD Block---------------
    let hoursIncrement = 0;
    let startHour = 8;
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blockIndex = Math.floor((refTs - dayStartTs) / 10800000);
    let startTimestamp = this.extremeWeatherDataService.getCurrentBlockTs(dayStartTs)
    console.log("startTimestamp",startTimestamp);
    
    const blocks = {};
    for (let i = 0; i < 8; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i + blockIndex) * 10800000);
      blocks[i]['timeStamp'] = startTimestamp + ((i * 10800000));      
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['toolTip'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['label'] = this.convertTimestampToBlockValue(blocks[i]['timeStamp']);
      blocks[i]['leftSideName'] = this.convertTimestampToFullBlockValue(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    let index = this.getCurrentBlockIndex(blocks)
    // console.log("BLOCKS::",blocks,index);
    blocks[8] = {};
    blocks[8]['timeStamp'] = blocks[index]['timeStamp'];
    blocks[8]['timeLineName'] = {};
    blocks[8]['timeLineName']['toolTip'] = this.convertTimestampToBlockValue(blocks[index]['timeStamp']) + '-' + this.convertTimestampToBlockValue(blocks[index]['timeStamp']);
    blocks[8]['timeLineName']['label'] = '24hr';
    blocks[8]['leftSideName'] = '24hr';
    blocks[8]['timeLinePos'] = 8;
    return blocks;
  }

  getCurrentBlockIndex(blocks) {
    const currentTime = new Date().getTime();
    let currentBlockIndex:any = 0; // Default value if not found
  
    for (const index in blocks) {
      const blockStartTime = blocks[index].timeStamp;
      const blockEndTime = blockStartTime + 3 * 60 * 60 * 1000; // 3 hours in milliseconds
  
      if (currentTime >= blockStartTime && currentTime < blockEndTime) {
        currentBlockIndex = index;
        break;
      }
    }
  
    return currentBlockIndex;
  }

  setAccurayData(data, loctype) {
    const finalData = {};
    const timeStampList = [];
    let table_data = [];
    let accData;
    let cumm_accuracy;
    const locationname = loctype == 'BLOCK' ? 'Mandal' : (loctype == 'VILLAGE' ? 'Village' : 'District');
    Object.keys(data).forEach(locId => {
      // console.log(locId)
      const locObject = {};
      locObject[locationname] = { val: this.utilService.formatNames(data[locId]['locName']), id: locId };
      locObject['raf'] = { val: (data[locId]['accuracyData']['arf']).toFixed(3) };
      Object.keys(data[locId]['accuracyData']['ad']).forEach(element => {
        const elemnt = element;
        if (!timeStampList.includes(elemnt)) {
          timeStampList.push(elemnt);
        }

        // console.log(elemnt)
        const forecast = data[locId]['accuracyData']['ad'][elemnt]['rfv'];
        const accuray = data[locId]['accuracyData']['ad'][elemnt]['rfa'];
        cumm_accuracy = data[locId]['accuracyData']['ad'][elemnt]['rfca'];
        locObject[elemnt + '_forecast'] = { val: forecast.toFixed(3) };
        locObject[elemnt + '_accuracy'] = { val: accuray.toFixed(3) };
        accData = !isNullOrUndefined(cumm_accuracy) ? cumm_accuracy.toFixed(3) : '-';
        if(!isNullOrUndefined(cumm_accuracy)) {
          locObject[elemnt + '_cummulative_accuracy'] = { val: accData };
        }
      });
      if (data[locId]['lat'] && data[locId]['lon']) {
        locObject['centroid'] = { 'lat': data[locId]['lat'], 'lon': data[locId]['lon'] };
      }
      table_data.push(locObject);
    });

    const sortedTimeStampList = timeStampList.sort();
    const column1 = [];
    column1.push({
      val: locationname,
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: locationname,
    });
    column1.push({
      val: 'Actual (mm)',
      colspan: 1,
      rowspan: 2,
      sortedHeaderVal: 'raf',
    });
    const column2 = [];
    const tableHeaders = [];
    tableHeaders.push({ val: locationname });
    tableHeaders.push({ val: 'raf' });

    for (const index in sortedTimeStampList) {
      const tp = sortedTimeStampList[index];
      // console.log(tp)
      let colsSpan;
      if(!isNullOrUndefined(cumm_accuracy)) {
        colsSpan = 3;
      } else {
        colsSpan = 2;
      }
      column1.push({
        val: (tp.replace(/_/g, ' ')).toUpperCase(),
        colspan: colsSpan,
        rowspan: 1,
        sortedHeaderVal: tp.toString() + '_d'
      });
      column2.push({
        val: 'Forecast (mm)',
        colspan: 1,
        rowspan: 1,
        backgroundColor: null,
        sortedHeaderVal: tp.toString() + '_forecast'
      });
      column2.push({
        val: 'Accuracy (%)',
        colspan: 1,
        rowspan: 1,
        backgroundColor: null,
        sortedHeaderVal: tp.toString() + '_accuracy'
      });
      if(!isNullOrUndefined(cumm_accuracy)) {
        column2.push({
          val: 'Cummulative Accuracy (%)',
          colspan: 1,
          rowspan: 1,
          backgroundColor: null,
          sortedHeaderVal: tp.toString() + '_cummulative_accuracy'
        });
      }
      
      tableHeaders.push({
        val: tp.toString() + '_forecast'
      });
      tableHeaders.push({
        val: tp.toString() + '_accuracy'
      });
      if(!isNullOrUndefined(cumm_accuracy)) {
        tableHeaders.push({
          val: tp.toString() + '_cummulative_accuracy'
        });
      }
      
    }
    const tableColumns = [];
    tableColumns.push(column1);
    tableColumns.push(column2);
    finalData['data'] = table_data;
    finalData['columns'] = tableColumns;
    finalData['tableHeaders'] = tableHeaders;
    // console.log(finalData)


    return finalData;
  }
  
  get10DaysTimeStamps(source,timestamp) {
    // ---------------33435 IMD Block---------------
    let hoursIncrement = 0;
    let startHour;
    if(timestamp.endsWith('00')) {
      startHour = 8
    } else {
      startHour = 20
    }
    // if (source == 'IMD') {
    //   hoursIncrement = ProjConstants.SOURCE_TIMESTAMP_DIFF.IMD;
    //   startHour = 8;
    // }
    const today = new Date();
    const refTs = today.getTime();
    // let refTs = ProjConstants.RefTs24;
    const start = new Date(refTs);
    start.setHours(startHour, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 7; i++) {
      blocks[i] = {};
      // blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000);
      blocks[i]['timeStamp'] = dayStartTs + ((i) * 86400000) - hoursIncrement;
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']+hoursIncrement);
      blocks[i]['timeLineName']['toolTip'] = source == 'IMD'? '8:30 AM - 8:30 AM': '5:30 AM - 5:30 AM';
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp']+hoursIncrement);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  validForecastFile(date) {
    let returnString = '';
    let currDate:any;
    if (date != null && date != undefined) {
      if (date.length == 10) {
        const Year = date[0] + date[1] + date[2] + date[3];
        const Month = date[4] + date[5];
        const DayOfMonth = date[6] + date[7];
        currDate = new Date(Year + '-' + Month + '-' + DayOfMonth);
      }
    }
    return currDate;
  }

  getWeeklyTimeStamps(value) {
    const refTs = this.validForecastFile(value);
    const start = new Date(refTs);    
    start.setHours(5, 30, 0, 0);
    const dayStartTs = start.getTime();
    const blocks = {};
    for (let i = 0; i < 6; i++) {
      blocks[i] = {};
      blocks[i]['timeStamp'] = dayStartTs + ((i) * (86400000*7));
      blocks[i]['timeLineName'] = {};
      blocks[i]['timeLineName']['label'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      blocks[i]['timeLineName']['toolTip'] = 'Week' + i.toString();
      blocks[i]['leftSideName'] = this.convetTimeStampToDay(blocks[i]['timeStamp']);
      blocks[i]['timeLinePos'] = i;
    }
    return blocks;
  }

  convertTimestampToBlockValue(ts) {
    ts = Number(ts);
    let hours = new Date(ts).getHours();
    const minutes = new Date(ts).getMinutes();
    let amPm = 'A.M';
    if (hours > 12) {
      hours = hours - 12;
      amPm = 'P.M';
    }
    return hours.toString() + ':' + minutes.toString() + ' ' + amPm;
  }

  convetTimeStampToDay(ts) {
    const date = new Date(ts).toLocaleDateString();
    return date;
  }

  convertTimestampToFullBlockValue(ts) {
    ts = Number(ts);
    let starthours = new Date(ts).getHours();
    const startminutes = new Date(ts).getMinutes();
    let startamPm = 'A.M';
    if (starthours > 12) {
      starthours = starthours - 12;
      startamPm = 'P.M';
    }
    let endhours = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getHours();
    const endminutes = new Date(ts + ProjConstants.MILLS_IN_3HOURS).getMinutes();
    let endamPm = 'A.M';
    if (endhours > 12) {
      endhours = endhours - 12;
      endamPm = 'P.M';
    }
    return starthours.toString() + ':' + startminutes.toString() + ' ' + startamPm + ' - ' + endhours.toString() + ':' + endminutes.toString() + ' ' + endamPm;
  }
}
